import {GenericList} from './GenericList';
import {Document} from "../../models/Document";

export class IndexingList extends GenericList<Document> {}
